<template>
  <div class="d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <component :is="componentId"></component>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import ErpTreeStatus from "../../Common/erp-tree-status";
import FurnishList from "./components/furnish/FurnishList";
import FurnishMain from "./components/furnish/FurnishMain";

export default {
  name: "FurnishMaster",
  components: {FurnishList, ErpTreeStatus,FurnishMain},
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  data(){
    return{
      mainObj:{
        house_name:"",
        house_id:"",
        id:""
      },
      componentId:"FurnishList",
    }
  },
  methods:{
    nodeClick(data) {
      const that=this;
      if(that.componentId != 'FurnishList') {
        that.$confirm('此操作会清空未保存的数据，是否跳转到转修列表页?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.componentId = 'FurnishList'
          }).catch(() => {

          });
      }else{
        that.mainObj.house_name = data.tree
          .map((ret) => {
            return ret.name;
          })
          .join("->");
        if (data.tree[data.tree.length - 1].type === "room") {
          that.mainObj.house_id = data.tree[data.tree.length - 1].id;
        } else {
          that.mainObj.house_id = 0;
        }
      }
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },

  },
}
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
  margin: 1%;
  width: 98%;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  //margin: 30px;
  width: 100%;
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/FurnishMaster.vue